import { Injectable } from '@angular/core';
import { BaseApiService, CurrencyTypes, TimeZonesEnum } from '@ep/shared';
import { catchError, Observable, of } from 'rxjs';
import { LanguageTypes } from '@shared/enums';

export interface CreateLocationRequest {
  MerchantId: number;
  Name: string;
  Address: string;
  PhoneNumber: number;
  TimeZoneType: TimeZonesEnum;
  CurrencyType?: CurrencyTypes;
  LanguageType?: LanguageTypes;
  Latitude: number;
  Longitude: number;
}

export interface UpdateLocationRequest {
  LocationId: number;
  MerchantId: number;
  Name: string;
  Address: string;
  PhoneNumber: number;
  TimeZoneType: TimeZonesEnum;
  CurrencyType: CurrencyTypes;
  LanguageType: LanguageTypes;
  Latitude: number;
  Longitude: number;
}

@Injectable({
  providedIn: 'root',
})
export class LocationService extends BaseApiService {
  private readonly locationEndpoint = `/v2/Locations`;

  findAll(merchantId: number): Observable<any> {
    return this.get(this.locationEndpoint, { merchantId }).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  findById(locationId: number): Observable<any> {
    return this.get(`${this.locationEndpoint}/${locationId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  create(createLocationRequest: CreateLocationRequest): Observable<any> {
    return this.post(this.locationEndpoint, createLocationRequest).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  update(updateLocationRequest: UpdateLocationRequest): Observable<any> {
    return this.patch(this.locationEndpoint, updateLocationRequest).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
}
